import React, { createContext, useState } from 'react'
import { useEffect } from 'react'
import { useFabricJSEditor } from '../hooks/editor'

export const EditorContext = createContext({})

const EditorProvider = ({children}) => {

  let initState = {
    fill: '#000000',
    fontSize: 40,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 1.12,
    textAlign: 'left',
    underline: false,
    stroke: "#000000",
    strokeWidth: 0,
    angle: 0,
  }

  const { onReady, editor, selectedObjects, selectObject, download } = useFabricJSEditor()
  const [textEditorOptions, setTextEditorOptions] = useState(initState)

  const resetField = (field) => {
    setTextEditorOptions(initState)
  }

  const contextValues = {
    onReady, editor, selectedObjects, textEditorOptions, setTextEditorOptions, resetField, selectObject, download
  }

  useEffect(()=> {
    if (selectedObjects.length > 0) {
      if (selectedObjects[0].type === 'text') {
        setTextEditorOptions({
          fill:selectedObjects[0].fill,
          fontSize:selectedObjects[0].fontSize,
          fontFamily:selectedObjects[0].fontFamily,
          fontStyle:selectedObjects[0].fontStyle,
          fontWeight:selectedObjects[0].fontWeight,
          lineHeight:selectedObjects[0].lineHeight,
          textAlign:selectedObjects[0].textAlign,
          textDecoration:selectedObjects[0].textDecoration,
          stroke:selectedObjects[0].stroke,
          angle:selectedObjects[0].angle,
        })
      }
      
    }
  }, [selectedObjects])

  return (
    <EditorContext.Provider value={contextValues}>
      {children}
    </EditorContext.Provider>
  )
}

export default EditorProvider